var exports = {
  "QX": "SmallMarginRight__rC9mXZ",
  "e3": "SmallScreenOnly__VNKUhx",
  "nQ": "HideOnSmallScreen__gxTxkH",
  "PA": "Truncate__cRkKiA",
};

module.exports = exports;
